import React from 'react';
import {
  House,
  Users,
  User,
  UserPlus,
  ClipboardText,
  Calendar,
  ChartBar,
  Tag,
  Pill,
  Receipt,
  ListBullets,
  Prescription,
  Package,
} from 'phosphor-react';

import PatientManager from '../Modules/Patients/patientManager';
import UserList from '../Modules/Admin/UserList';
import PendingLabTest from '../Modules/Lab/pendingLabTest';
import LabTechDashboard from '../Dashboards/Dedicated Dashboard Page/labTechnicianDashboard';
import AddPatientPage from '../Modules/Patients/Reception/addPatient';
import ReceptionistDashboard from '../Dashboards/Dedicated Dashboard Page/receptionistDashboard';
import AddAppointment from '../Modules/Appointments/addAppointment';
import DoctorDashboard from '../Dashboards/Dedicated Dashboard Page/doctorDashboard';
import PatientQueueList from '../Modules/Patients/Reception/PatientQueueList';
import PharmacyDashboard from '../Dashboards/Dedicated Dashboard Page/pharmacyDashboard';
import PrescriptionQueueList from '../Modules/Prescriptions/PrescriptionQueue/PrescriptionQueueList';
import InventoryFormPage from '../Modules/PharmacyInventory/InventoryFormPage';
import InventorySection from '../Modules/PharmacyInventory/InventorySection';
import LabSupplyFormPage from '../Modules/LabSupplies/LabSupplyFormPage';
import LabSupplySection from '../Modules/LabSupplies/LabSupplySection';
import PatientLabHistory from '../Modules/Lab/PatientLabHistory';
import BillingSection from '../Modules/Bills/BillingSection';
import DispensationLog from '../Modules/Prescriptions/DispensationLog';
import KalendaApp from '../Modules/Appointments/calendar';
import QueueList from '../Modules/Patients/queue';
import AdminDashboard from '../Dashboards/Dedicated Dashboard Page/adminDashboard';
import PricingManagement from '../Modules/Admin/PricingManagement';
import ReportsManagement from '../Modules/Admin/Reports/ReportsManagement';
import OrganizationPanel from '../Modules/Admin/OrganizataData/organizationPanel';
import AuditDashboard from '../Modules/Admin/AuditEvents';

const iconProps = {
  size: 20,
  weight: 'light',
  color: 'var(--icon-color)',
};

export const menuConfig = {
  doctor: [
    {
      key: 'dashboard', label: 'Dashboard', icon: <House {...iconProps} />, component: DoctorDashboard,
    },
    {
      key: 'today_queue', label: 'Patient Queue', icon: <UserPlus {...iconProps} />, component: (props) => <QueueList  role="doctor" />,
    },
    {
      key: 'patients', label: 'Patients', icon: <Users {...iconProps} />, component: (props) => <PatientManager  role="doctor" />,
    },
     {
      key: 'book_appointment', label: 'Book an Appointment', icon:  <Calendar {...iconProps} />, component: (props) =>  
      <AddAppointment user={props.user} 
      initialData={props.initialData} 
      onSave={() => props.navigateTo('calendar_app')} 
      onCancel={() => props.navigateTo('calendar_app')} 
    />,

    },
   {
      key: 'calendar_app', label: 'Appointments', icon: <ClipboardText {...iconProps} />, component: (props) =>  <KalendaApp  navigateTo={props.navigateTo} /> ,

    }
  ],
  admin: [
    {
      key: 'dashboard', label: 'Dashboard', icon: <House {...iconProps} />, component: (props) =>  <AdminDashboard  user={props.user} navigateTo={props.navigateTo}  /> ,
    },
    {
      key: 'users', label: 'Users', icon:  <Users {...iconProps} />, component: UserList ,
    },
      {
      key: 'pricing',
      label: 'Services',
      icon: <Tag {...iconProps} />,
      component: PricingManagement
    },
     {
      key: 'reports', label: 'Reports', icon: <ChartBar {...iconProps} />, component: ReportsManagement ,
    },
    {
    key: 'clinic_details',
    label: 'Clinic Details',
    icon: <ClipboardText {...iconProps} />,
    component: OrganizationPanel
    },
    {
    key: 'audit_trail',
    label: 'Audit Trail',
    icon: <ListBullets {...iconProps} />,
    component: AuditDashboard,
  },
     {
      key: 'lab_supplies_list', label: 'Lab Supplies', icon: <Package {...iconProps} />, component: LabSupplySection,
    },
   
   ],
  receptionist: [

    {
      key: 'dashboard', label: 'Dashboard', icon: <House {...iconProps} />, component: (props) => <ReceptionistDashboard user={props.user} navigateTo={props.navigateTo} />,
    },
    {
      key: 'patients_queue', label: 'Patient Queue', icon: <Users {...iconProps} />,  component: (props) => <PatientQueueList role="receptionist" />,
    },
    {
      key: 'patient_bills', label: 'Billing Log', icon: <Receipt  {...iconProps} />, component: BillingSection ,
    },
    {
      key: 'new_patients', label: 'Add Patient', icon: <UserPlus {...iconProps} />, component: (props) => < AddPatientPage navigateTo={props.navigateTo} />,
    },
    {
      key: 'all_patients', label: 'All Patients', icon: <User {...iconProps} />,  component: (props) => <PatientManager  role="receptionist" navigateTo={props.navigateTo} />,

    },
    {
      key: 'book_appointment', label: 'Book an Appointment', icon: <Calendar {...iconProps} />, component: (props) =>  
      <AddAppointment user={props.user} 
      initialData={props.initialData} 
      onSave={() => props.navigateTo('calendar_app')} 
      onCancel={() => props.navigateTo('calendar_app')} 
    />,

    },
   {
      key: 'calendar_app', label: 'Appointments', icon: <ClipboardText {...iconProps} />, component: (props) =>  <KalendaApp  navigateTo={props.navigateTo} /> ,

    }
  ],

  lab_technician: [
    {
      key: 'dashboard', label: 'Dashboard', icon: <House {...iconProps} />, component: (props) =>  <LabTechDashboard user={props.user} navigateTo={props.navigateTo} />,
    },
    {
      key: 'tests', label: 'Lab Tests', icon: <ClipboardText {...iconProps} />, component: PendingLabTest,
    },
    {
      key: 'add_lab_supply', label: 'Add Supply', icon: <Package {...iconProps} />, component: (props) => <LabSupplyFormPage {...props} />,
    },
    {
      key: 'lab_supplies_list', label: 'Lab Supplies', icon: <Package {...iconProps} />, component: LabSupplySection,
    },
    {
      key: 'patient_lab_history', label: 'Lab Test History', icon: <ClipboardText {...iconProps} />, component: PatientLabHistory,
    },
  ],
  pharmacist: [
    {
      key: 'dashboard', label: 'Dashboard', icon: <House {...iconProps} />,  component: (props) =>  <PharmacyDashboard user={props.user}  navigateTo={props.navigateTo}/>,
    },
    {
      key: 'Prescription_queue', label: 'Prescription Queue', icon: <Prescription {...iconProps} />, component: PrescriptionQueueList,
    },
    {
      key: 'add_med', label: 'Add Medicine', icon:  <Pill {...iconProps} />, component: (props) => <InventoryFormPage {...props} />,
    },
    {
      key: 'inventory_list', label: 'Medications', icon: <Package {...iconProps} />, component: InventorySection,
    },
      {
      key: 'dispensation_log', label: 'Dispense log', icon: <ListBullets {...iconProps} />, component: DispensationLog,
    },
  ],
};
